export default __webpack_public_path__ + "static/media/15.d345ecdc.png";